import { Core } from "@/core/Core";

export default {

  async getCustomer(context, {id}) {
    try {
      return await Core.request("GET", "/api/customers/" + id);
    } catch (e) {
      return null;
    }
  },

  async getDispatchCustomer(context, {id}) {
    try {
      return await Core.request("GET", "/api/user_informations/" + id);
    } catch (e) {
      return null;
    }
  },

  async getCustomerAdminAnalysis(context, {id}) {
    try {
      return await Core.request("GET", `/api/customers/${id}/admin-analysis`);
    } catch (e) {
      return null;
    }
  },

  async getUser(context, {id}) {
    try {
      return await Core.request("GET", "/api/users/" + id);
    } catch (e) {
      return null;
    }
  },

  async createUser(context, {data}) {
    try {
      return await Core.request("POST", "/api/users", data);
    } catch (e) {
      return null;
    }
  },

  async saveUser(context, {id, data}) {
    try {
      return await Core.request("PUT", "/api/users/" + id, data);
    } catch (e) {
      return null;
    }
  },

  async deleteUser(context, {id}) {
    try {
      return await Core.request("DELETE", "/api/users/" + id + "/hard");
    } catch (e) {
      return null;
    }
  },

  async hardDeleteUser(context, {id, attachToAnonymous}) {
    try {
      let url = attachToAnonymous
        ? `/api/users/${id}/hard_detach`
        : `/api/users/${id}/hard`;

      return await Core.request("DELETE", url);
    } catch (e) {
      return null;
    }
  }

}